import { AxiosResponse } from "axios";
import { updateLocalStorage } from "~utils";
import {LOCAL_STORAGE_NAME} from "~utils/constants/attributes-const";

interface NewContactCount {
  admin: number;
  user: number;
}

interface _Response_<T> {
    data: T;
    new_contact_count?: NewContactCount;
    error?: {
        status?: boolean;
        code?: number;
        message?: { [key: string]: string[] } | string;
        transfer_error?: boolean;
    };
}

class APIResponse<T> {
    public res;

    public get statusCode() {
        return this.res.status;
    }

    public get data(): T {
        const data = this.res.data.data;
        return data;
    }

    public constructor(res: AxiosResponse<_Response_<T>>) {
      const data = res.data;
      if (data && data.new_contact_count) {
        updateLocalStorage(LOCAL_STORAGE_NAME.NEW_USER_CONTACTS, data.new_contact_count.user);
        updateLocalStorage(LOCAL_STORAGE_NAME.NEW_ADMIN_CONTACTS, data.new_contact_count.admin);
        delete res.data.new_contact_count;
      }

      this.res = res;
    }

    public hasError() {
        if (this.res.status != 200) {
            return true;
        }
        if (!this.res.data.data) {
            return true;
        }
        if (this.res.data.error?.status === true) {
            return true;
        }
        return false;
    }

    public getErrorMessages() {
        if (!this.res.data.error) {
            return [];
        }
        const messages = this.res.data.error.message;
        if (typeof messages === "string") {
            return [messages];
        }
        const arr: string[] = [];
        for (let k in messages) {
            const list = messages[k];
            for (let i = 0; i < list.length; i++) {
                arr.push(list[i]);
            }
        }
        return arr;
    }

    // [特殊] IB連携 振込エラー
    public hasTransferError() {
        if (this.res.data.error?.transfer_error === true) {
            return true;
        }
        return false;
    }
    //メッセージエラーを取得
    public get errors(): T {
      if(this.res.data.error){
        return this.res.data.error.message
      }
      return this.res.data.error
    }

    public get getErrCode(): T {
      return this.res.data.error.code;
    }
}

export { APIResponse };
